import React, { useRef, useState } from 'react'
import AssetsFormSections from 'components/assets/form_sections';
import { Form } from 'common/components';
import classnames from 'classnames';
import { putEditBill } from '../actions';
import AssetsBillTable from '../../../modules/secured/modules/assets/AssetsBillTable';
import AssetBillRow from '../../../modules/secured/modules/assets/AssetBillRow';
import * as Common from 'common/components';
import BillsAddButton from '../../../components/assets/form_sections/BillsAddButton';
import { formatMoney } from 'accounting-js';

const dateFormat = (_d) =>{

    if(_d){
      let date = _d.toString()
      let dateCondition = date.split(" ")
      if (dateCondition.length > 1) {
          let dateArray = date.split(" ")

          if(dateArray[1] === 'Jan')
            dateArray[1] = '01'
          else if(dateArray[1] === 'Feb')
            dateArray[1] = '02'
          else if(dateArray[1] === 'Mar')
            dateArray[1] = '03'
          else if(dateArray[1] === 'Apr')
            dateArray[1] = '04'
          else if(dateArray[1] === 'May')
            dateArray[1] = '05'
          else if(dateArray[1] === 'Jun')
            dateArray[1] = '06'
          else if(dateArray[1] === 'Jul')
            dateArray[1] = '07'
          else if(dateArray[1] === 'Aug')
            dateArray[1] = '08'
          else if(dateArray[1] === 'Sep')
            dateArray[1] = '09'
          else if(dateArray[1] === 'Oct')
            dateArray[1] = '10'
          else if(dateArray[1] === 'Nov')
            dateArray[1] = '11'
          else if(dateArray[1] === 'Dec')
            dateArray[1] = '12'

          return dateArray[2]+"/"+dateArray[1]+"/"+dateArray[3]
      }
      else{
          let dateArray1 = date.split("T")
          let dateArray = dateArray1[0].split("-")
  
          if(dateArray[1] === 'Jan')
            dateArray[1] = '01'
          else if(dateArray[1] === 'Feb')
            dateArray[1] = '02'
          else if(dateArray[1] === 'Mar')
            dateArray[1] = '03'
          else if(dateArray[1] === 'Apr')
            dateArray[1] = '04'
          else if(dateArray[1] === 'May')
            dateArray[1] = '05'
          else if(dateArray[1] === 'Jun')
            dateArray[1] = '06'
          else if(dateArray[1] === 'Jul')
            dateArray[1] = '07'
          else if(dateArray[1] === 'Aug')
            dateArray[1] = '08'
          else if(dateArray[1] === 'Sep')
            dateArray[1] = '09'
          else if(dateArray[1] === 'Oct')
            dateArray[1] = '10'
          else if(dateArray[1] === 'Nov')
            dateArray[1] = '11'
          else if(dateArray[1] === 'Dec')
            dateArray[1] = '12'
  
          return dateArray[2]+"/"+dateArray[1]+"/"+dateArray[0]
      }
    }
    else
      return null
}
const AssetsEditBill = (props) => {
  const {
    asset,
    company,
    depreciations,
    subcompany,
    accounts,
    catalogs,
    costCenters,
    employees,
    inpcs,
    isLoading,
    locations,
    projects,
    providers,
    subaccounts,
    sublocations,
    asset_levels,
    history
  } = props;
  const [files, setFiles] = useState([])
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [values, setValues] = useState({
    "billNumber":"",
    "billFolio":"",
    "billDate":"",
    "billConcept":"",
    "billImport":""
  })
  let totalImports = 0
  var fechaInicial;
  var fechaFinal;
  
  if (asset._bills && asset._bills.length > 0) {

    if (asset._bills[0].billDate !== undefined) 
      fechaInicial = asset._bills[0].billDate

    else if(asset._bills[1].billDate !== undefined)
      fechaInicial = asset._bills[1].billDate

    if (asset._bills[0].billDate !== undefined) 
      fechaFinal = asset._bills[0].billDate

    else if(asset._bills[1].billDate !== undefined)
      fechaFinal = asset._bills[1].billDate
  
    // fechaInicial = asset._bills[0].billDate ? asset._bills[0].billDate : asset._bills[1].billDate
    // fechaFinal = asset._bills[0].billDate ? asset._bills[0].billDate : asset._bills[1].billDate

      for (const bill in asset._bills) {

        if(asset._bills[bill].billImport)
          totalImports += asset._bills[bill].billImport

        for (let index = parseInt(bill)+1; index < asset._bills.length; index++) {

          if(asset._bills[index].billDate){
            if (fechaInicial > asset._bills[index].billDate ) {
              fechaFinal = fechaInicial
              fechaInicial = asset._bills[index].billDate
            }
            else if( asset._bills[index].billDate > fechaFinal)
              fechaFinal = asset._bills[index].billDate
          }
        }
        
        // if(Date.parse(asset._bills[parseInt(bill)+1].billDate) < Date.parse(asset._bills[parseInt(bill)].billDate)){
      }
      fechaInicial = dateFormat(fechaInicial)
      fechaFinal = dateFormat(fechaFinal)    
  }

  const handleValueChange = (e) =>{
    if (e._d) {
      setValues({...values, [e.target.name]: e.target.value, billDate: e._d})      
    }
    else{
      setValues({...values, [e.target.name]: e.target.value})
    }
  }
  
  const handleSubmit = (e) =>{

    e.preventDefault()
    putEditBill(asset.id, company.id, subcompany.id, values, files)
    .then((resultado) => {
      if (resultado.payload) {
        // history.push(`/companies/${company.id}/subcompanies/${company.id}/assets/${asset.id}/edit`)
        // history.go(0)
        history.goBack()
      }
    })
    .catch((error) => {
      console.error(error);
    });
    setFiles([])
  }
  const hiddenFileInput = useRef(null); 

  const handleClick = event => {
    hiddenFileInput.current.click();   
  };
  const handleFileChange = (e) =>{
    setFiles([...files, e.target.files[0]])
  }
  return (
    <Common.Wrapper fluid={true}>
      <div className="col-12">
      <Common.Portlet
        title={'Facturas multiples'}
        button={<BillsAddButton setIsCollapsed={setIsCollapsed} isCollapsed={isCollapsed} />}
      >

        {isCollapsed 
          ? 
            null
          :
          <form onSubmit={(e)=>handleSubmit(e)} noValidate autoComplete="false">
            <AssetsFormSections.Bill
              handleValueChange={handleValueChange}
              handleFileChange={handleFileChange}
              handleClick={handleClick}
              hiddenFileInput={hiddenFileInput}
              values={values}
              name={files.length > 0 ? files : ''}
            />
            
            <div className="col-md-12 mt-3">
              <Form.Button
                type={'submit'}
                text='Guardar'
                extraClassName={'pull-right btn-xs-block'}
              />

              <div className="clearfix" />
            </div>
          </form>
        }

        <div className="mb-2 mt-5" style={{ position: 'relative' }}>

          <div style={{display:'flex', flexDirection:'row'}}>
            <div style={{marginRight: '20px'}}>
              {asset._bills ? `Total de facturas: ${asset._bills.length}` :'Total de facturas: 1'}
            </div>
            <div style={{marginRight: '20px'}}>
              {asset._bills ? `Total importe: ${formatMoney(totalImports/100)}` :`Total importe: ${asset.billImport ? formatMoney(asset.billImport): '-'}`}
            </div>
            <div>
              {fechaInicial && fechaFinal ? `Desde ${fechaInicial} al ${fechaFinal}` : null}
            </div>
          </div>
          <br/>

          <AssetsBillTable
            count={asset._bills ? asset._bills.length : 1}
          >
            {
              asset._bills 
               ?
               asset._bills.map((bill)=><AssetBillRow bill={bill}/>)
                :
                  <AssetBillRow bill={{
                    "billNumber":asset.billNumber,
                    "billFolio":asset.billFolio,
                    "billDate":asset.billDate,
                    "billConcept":asset.billConcept,
                    "billImport":asset.billImport
                  }}/>
                
            }
          </AssetsBillTable>
        </div>
      </Common.Portlet>
      </div>
    </Common.Wrapper>
  )
}

export default AssetsEditBill


// WEBPACK FOOTER //
// src/containers/assets/edit_sections/AssetsEditBill.js